exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.skill-assessment-item[data-v-f3a926f4] {\n  background-color: #EAF0F6 !important;\n  padding: 20px !important;\n  border-radius: 0;\n  margin-top: 6px;\n}\n", ""]);

// exports
